import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { keycloak } from './login/keycloakConfig.tsx';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

const ProfileDropdown = () => {
    const navigate = useNavigate();
    const roleName = sessionStorage.getItem("roleName");
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const userName = sessionStorage.getItem('userName') || '';

    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const handleLogout = async () => {
        try {
            if (sessionStorage.getItem("redirectedFromUMP") === "true") {
                sessionStorage.clear();
                localStorage.clear();
                window.location.href = `${window.env.REACT_APP_UMP_REDIRECT_URL}/home`;
                return;
            }

            const environment = localStorage.getItem("environment");

            if (environment === "Native") {
                try {
                    await axios.put(
                        `${window.env.REACT_APP_UMP_URL}/logout`,
                        {},
                        {
                            headers: {
                                Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
                            }
                        }
                    );
                } catch (err) {
                    console.error('Backend logout failed:', err);
                }

                sessionStorage.clear();
                localStorage.clear();
                window.location.href = "/signIn";
                return;
            }

            if (environment === "Keycloak" || environment === "Azure" || environment === "Google") {
                if (keycloak && keycloak.authenticated) {
                    sessionStorage.clear();
                    localStorage.clear();
                    keycloak.logout({
                        redirectUri: `${window.env.REACT_APP_UI_URL}/signIn`,
                    });
                } else {
                    sessionStorage.clear();
                    localStorage.clear();
                    window.location.href = "/signIn";
                }
                return;
            }

            sessionStorage.clear();
            localStorage.clear();
            window.location.href = "/signIn";
        } catch (err) {
            console.error("Error logging out:", err);
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = "/signIn";
        }
    };

    return (
        <Dropdown
            isOpen={isProfileDropdown}
            toggle={toggleProfileDropdown}
            className="header-item"
            direction="down"
        >
            <DropdownToggle
                tag="button"
                type="button"
                className="btn shadow-none"
                caret={false}
            >
                <span className="d-flex align-items-center">
                    <i className="ri-account-circle-line fs-3 text-muted"></i>
                </span>
            </DropdownToggle>

            <DropdownMenu end className="profile-dropdown">
                <h6 className="dropdown-header">Welcome {userName || "User"}!</h6>

                {roleName !== 'ISPPartnerAdmin' && (
                    <DropdownItem
                        onClick={() => {
                                navigate(`/profile`);
                        }}
                    >
                        <i className="ri-profile-line text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Profile</span>
                    </DropdownItem>
                )}

                <div className="dropdown-divider"></div>

                <DropdownItem onClick={handleLogout}>
                    <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                    <span className="align-middle" data-key="t-logout">Logout</span>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default ProfileDropdown;